export { default } from './CustomPrismicLink';
